export const valid = "#32936F";
export const invalid = "#E84B58";
export const inProgress = "#FA9600";
export const notEvaluated = "#232A35";

